<template>
  <p class="text-sm text-black1 md:text-base"><slot /></p>
</template>
